
import React, { useState, useRef} from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import config from '../../config/config.js';


const useStyles = makeStyles((theme) => ({
  dialog: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
  paper: {
    backgroundColor: '#bef4ffff',
    maxWidth: '900px',
    maxHeight: '95%',
    width: '90%',
    borderRadius: '20px',
    margin: '16px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '700px',
      width: '85%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      maxHeight: '90%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '98%',
      height: '70%',
      maxHeight: '70%',
      margin: 0,
      borderRadius: 10,
    },
  },
  dialogContent: {
    paddingTop:'50px !important',
    padding: '50px',
    backgroundColor: '#fafeffff',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '40px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '30px 25px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '60px 20px 30px',
    },
  },
  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    cursor: 'pointer',
    color: '#999',
    zIndex: 1,
    '&:hover': {
      color: '#666',
    },
    [theme.breakpoints.down('xs')]: {
      top: '15px',
      right: '15px',
    },
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: '50px',
    alignItems: 'start',
    [theme.breakpoints.down('md')]: {
      gap: '40px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '40px',

    },
  },
  leftColumn: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },
  title: {
    fontSize: '40px',
    fontWeight: '700',
    color: '#0066cc',
    marginBottom: '20px',
    marginTop: 0,
    lineHeight: '1.2',
    [theme.breakpoints.down('md')]: {
      fontSize: '36px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '32px',
      marginBottom: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '28px',
    },
  },
  description: {
    color: '#333',
    marginBottom: '40px',
    lineHeight: '1.6',
    fontSize: '16px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
      marginBottom: '30px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      marginBottom: '25px',
    },
  },
  contactItem: {
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '20px',
      gap: '12px',
    },
  },
  contactIcon: {
    color: '#0066cc !important',
    fontSize: '28px',
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      fontSize: '24px',
    },
  },
  contactLink: {
    fontSize: '18px',
    color: '#333',
    textDecoration: 'none',
    fontWeight: '500',
    wordBreak: 'break-word',
    '&:hover': {
      color: '#0066cc',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '15px',
    },
  },
  formContainer: {
    backgroundColor: 'white',
    padding: '32px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    [theme.breakpoints.down('sm')]: {
      padding: '28px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '24px',
    },
  },
  input: {
    width: '100%',
    padding: '8px 18px',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    fontSize: '15px',
    marginBottom: '10px',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    backgroundColor: 'white',
    color: '#333',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    '&:focus': {
      borderColor: '#0066cc',
      boxShadow: '0 0 0 3px rgba(0, 102, 204, 0.1)',
    },
    '&::placeholder': {
      color: '#999',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '12px 16px',
      fontSize: '14px',
      marginBottom: '14px',
    },
  },
  textarea: {
    width: '100%',
    padding: '14px 18px',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    fontSize: '15px',
    marginBottom: '16px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    color: '#333',
    minHeight: '120px',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    '&:focus': {
      borderColor: '#0066cc',
      boxShadow: '0 0 0 3px rgba(0, 102, 204, 0.1)',
    },
    '&::placeholder': {
      color: '#999',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '12px 16px',
      fontSize: '14px',
      marginBottom: '14px',
      minHeight: '100px',
    },
  },
  message: {
    padding: '12px 16px',
    borderRadius: '6px',
    marginBottom: '16px',
    fontSize: '14px',
    [theme.breakpoints.down('xs')]: {
      padding: '10px 14px',
      fontSize: '13px',
      marginBottom: '14px',
    },
  },
  submitButton: {
    lineHeight: '2.6',
    width: '100%',
    padding: '14px',
    backgroundColor: '#0066cc',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#0052a3',
    },
    '&:disabled': {
      backgroundColor: '#80b3e6',
      cursor: 'not-allowed',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '12px',
      fontSize: '15px',
    },
  },
}));

export default function ModalNewContactUs({ open, onClose }) {
  const partnerSlug = window.location.pathname.split("/").filter(Boolean).pop();
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone_number: "",
    title: "",
    company_name: "",
    user_question: "",
    location: "",
    partner:partnerSlug
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const lastKey = useRef(null);

  const handleKeyDown = (e) => {
    lastKey.current = e.key;
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone_number') {

      //  Allow normal deletion
      if (lastKey.current === 'Backspace' || lastKey.current === 'Delete') {
        setFormData(prev => ({
          ...prev,
          phone_number: value
        }));
        return;
      }

      let digits = value.replace(/\D/g, '');

      if (digits.startsWith('1')) digits = digits.slice(1);
      digits = digits.slice(0, 10);

      const p1 = digits.slice(0, 3);
      const p2 = digits.slice(3, 6);
      const p3 = digits.slice(6, 10);

      let formatted = '+1 ';
      if (p1) formatted += `(${p1}`;
      if (p1.length === 3) formatted += ') ';
      if (p2) formatted += p2;
      if (p2.length === 3) formatted += '-';
      if (p3) formatted += p3;

      setFormData(prev => ({
        ...prev,
        phone_number: formatted
      }));
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };



  const handleSubmit = async () => {
    // Validate only required fields: full_name and email
    if (!formData.full_name.trim() || !formData.email.trim()) {
      setMessage({ type: 'error', text: 'Please fill in all the required fields.' });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setMessage({ type: 'error', text: 'Please enter a valid email address.' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });
    let authorise = process.env.REACT_APP_API_KEY

    try {
      const response = await fetch(`${config.baseUrlCP}userfaq/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${authorise}`,
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setMessage({ type: 'success', text: 'Thank you! We\'ll be in touch soon.' });
        setFormData({
          full_name: "",
          email: "",
          phone_number: "",
          title: "",
          company_name: "",
          user_question: "",
          location: ""
        });
      } else {
        setMessage({ type: 'error', text: 'Something went wrong. Please try again.' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Unable to submit. Please try again later.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth={false}
      fullScreen={isMobile}
      className={classes.dialog}
      PaperProps={{
        className: classes.paper
      }}
    >
      <MuiDialogContent className={classes.dialogContent}>
        <IconButton 
          aria-label="close" 
          className={classes.closeButton}
          onClick={onClose}
          style={{width:"1px", height:"2px"}}
          
        >
          <CloseIcon />
        </IconButton>

        <div className={classes.gridContainer}>
          {/* Left Column */}
          <div className={classes.leftColumn}>
            <h2 className={classes.title}>
              Contact Us
            </h2>
            <p className={classes.description}>
              Let us know what we can help you with and we will be in touch soon!
            </p>

            <div className={classes.contactItem}>
              <PhoneIcon className={classes.contactIcon}  style={{fill:'#0066cc'}} />
              <a 
                href="tel:5128949629" 
                className={classes.contactLink}
              >
                (512) 894-9629
              </a>
            </div>

            <div className={classes.contactItem} style={{marginBottom: 0}}>
              <EmailIcon className={classes.contactIcon} style={{fill:'#0066cc'}} />
              <a 
                href="mailto:info@calqueinc.com" 
                className={classes.contactLink}
              >
                info@calqueinc.com
              </a>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className={classes.formContainer}>
            <input
              type="text"
              name="full_name"
              placeholder="Full Name *"
              value={formData.full_name}
              onChange={handleChange}
              className={classes.input}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address *"
              value={formData.email}
              onChange={handleChange}
              className={classes.input}
              required
            />

            <input
              type="tel"
              name="phone_number"
              value={formData.phone_number}
              placeholder="+1 (   )    -    "
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              className={classes.input}
            />


            <input
              type="text"
              name="title"
              placeholder="Title / Position"
              value={formData.title}
              onChange={handleChange}
              className={classes.input}
            />

            <input
              type="text"
              name="company_name"
              placeholder="Company Name"
              value={formData.company_name}
              onChange={handleChange}
              className={classes.input}
            />

            <textarea
              name="user_question"
              placeholder="Message"
              value={formData.user_question}
              onChange={handleChange}
              className={classes.textarea}
            />

            {message.text && (
              <div 
                className={classes.message}
                style={{
                  backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
                  color: message.type === 'success' ? '#155724' : '#721c24',
                }}
              >
                {message.text}
              </div>
            )}

            <button
              onClick={handleSubmit}
              disabled={loading}
              className={classes.submitButton}
            >
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </MuiDialogContent>
    </Dialog>
  );
}